import React from 'react';

import cx from 'classnames';

import { withNotificationCenter } from 'components/shared/LandingPage/blocks/PageHeader/utils';
import Tooltip from 'components/shared/Tooltip';

import s from './index.module.css';
import { ILandingActionsProps } from './types';

const LandingActions = ({ icons, notifications }: ILandingActionsProps) => {
  return (
    <div className={s.iconsContainer}>
      {icons.map((icon, i) => {
        const IconComponent = <>{icon.icon}</>;

        return (
          <div key={icon.type + i}>
            <span onClick={icon.onClick} className={cx(s.icon, icon.isDisabled && s.disabledIcon)}>
              {icon.customElement ? withNotificationCenter(IconComponent, notifications) : IconComponent}
            </span>
            <Tooltip id={icon.type} place="left">
              {icon.isDisabled ? 'Active on live itinerary link when shared.' : icon.hint}
            </Tooltip>
          </div>
        );
      })}
    </div>
  );
};

export default LandingActions;
